// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"222fbf6d","557":"21da9dff","621":"073ed0e6","651":"9cad082b"}[chunkId] + ".chunk.js";
};